import { connect } from 'react-redux';

import { getIsMobile } from 'src/store/view/selectors';
import {
  getHotelTitle,
  getHotelLinkWithRequestId,
  getHotelPublicUrl,
} from '../../../../../store/selectors/hotel';

import ArchivePackageBanner from './ArchivePackageBanner';

const mapStateToProps = (state) => ({
  hotelName: getHotelTitle(state),
  isMobile: getIsMobile(state),
  hotelUrl: getHotelLinkWithRequestId(state) || getHotelPublicUrl(state),
});

export default connect(mapStateToProps)(ArchivePackageBanner);
